// Catalog and checkout share the same whole-pound EGP amount.
export const wholeEgp = (amount) => Math.floor(Number(amount) || 0);

export const formatEgp = (amount) =>
  `${wholeEgp(amount).toLocaleString("en-US")} EGP`;
